import { Empty } from 'antd'

import './index.scss'

type EmptyContentProps = {
  description?: string
  content?: React.ReactNode
}
export const EmptyContent = ({
  description = 'В списке пока нет ни одной записи',
  content,
}: EmptyContentProps) => {
  return (
    <section className="empty-section">
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={description}>
        {content}
      </Empty>
    </section>
  )
}
